// extracted by mini-css-extract-plugin
export default {"main":"OnboardingLandingPage_main__dyFWt","main_activate":"OnboardingLandingPage_main_activate__MAjw5"};